/*
 * @Date: 2026-01-27 00:39:34
 * @LastEditors: ryan.zheng@momenta.ai
 * @LastEditTime: 2026-03-14 17:21:11
 */
import { definePageConfig } from 'ice';
import { Row} from 'antd';

export default function Dashboard() {
  return (
    <Row gutter={[16, 16]}>
    </Row>
  );
}

export const pageConfig = definePageConfig(() => ({
  title: 'Dashboard',
}));
